import * as React from 'react';

import classnames from 'classnames';

import styles from './legacy-setup-table-container.module.css';

type Props = {
    canLoadMore?: boolean;
    overflow?: 'show' | 'hide' | 'auto' | 'scroll';
    children: React.ReactNode;
    wrapsEntireTable?: boolean;
};

export function LegacySetupTableContainer(props: Props) {
    const {overflow = 'auto'} = props;

    const styleName = classnames(styles['table-container'], {
        [styles['table-container--with-more']]: props.canLoadMore,
        [styles['table-container--show-overflow']]: overflow === 'show',
        [styles['table-container--hide-overflow']]: overflow === 'hide',
        [styles['table-container--wraps-entire-table']]: props.wrapsEntireTable,
    });

    return <div className={styleName}>{props.children}</div>;
}
